import {
  AdminDollarInput2,
  AdminInput,
  Button,
  Div,
  ErrorToast,
  H3,
  Img,
  Modal,
  SuccessToast,
  moneyCoins,
  updateAgentPendingBalance,
  useUsers,
  reportError,
} from '@vgrubs/components';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';

export const UserAgentEditPendingEarnings = ({
  id,
}: {
  id: number | undefined;
}) => {
  const [amount, setAmount] = useState(0);
  const [adminPassword, setAdminPassword] = useState('');
  const [reason, setReason] = useState('');

  const {
    editPendingBalanceModal,
    setEditPendingBalanceModal,
    setLoading,
    bank,
    setBank,
  } = useUsers((state) => state);

  const pendingBalance = bank?.agentBalance?.pendingBalance;

  async function handleAddBank() {
    if (!amount) {
      return ErrorToast('Please enter a balance');
    }

    if (!reason.trim()) {
      return ErrorToast('Please enter a reason');
    }

    if (!adminPassword.trim()) {
      return ErrorToast('Please enter the admin password');
    }

    if (Number(amount) === pendingBalance)
      return ErrorToast('Please enter a different balance');

    if (!id) {
      return;
    }

    try {
      setLoading(true);

      const body = {
        amount,
        adminPassword,
        reason,
      };

      const { data } = await updateAgentPendingBalance(id, body);
      SuccessToast(data.message);

      setBank({
        ...bank,
        agentBalance: {
          date: bank?.agentBalance?.date ?? '',
          currency: bank?.agentBalance?.currency ?? '',
          pendingBalance: amount,
        },
        balance: bank?.balance ?? {
          availableBalance: 0,
          reservedBalance: 0,
          currency: '',
        },
        pendingBalance: bank?.pendingBalance ?? 0,
        isBankConnected: !!bank?.isBankConnected,
      });

      setEditPendingBalanceModal(false);
      setAmount(0);
      setAdminPassword('');
      setReason('');
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (pendingBalance) {
      setAmount(pendingBalance);
    }
  }, [pendingBalance]);

  const handleAmountChange = useCallback((val) => {
    setAmount(val);
  }, []);

  return (
    <Modal
      isOpen={editPendingBalanceModal}
      closeModal={() => setEditPendingBalanceModal(false)}
      logo={false}
    >
      <Img width={230} src={moneyCoins} alt="edit balance" />

      <H3 $m="24px 0">Edit Pending Balance</H3>
      <Div $flex $column $gap="20px" $gapSM="16px">
        <AdminDollarInput2
          label="Pending Balance"
          onValueChange={handleAmountChange}
          value={amount}
          $textCenter
        />

        <AdminInput
          label="Reason"
          placeholder="Why is the balance being corrected?"
          value={reason}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setReason(e.target.value)
          }
          type="textarea"
          $textareaHeight={120}
        />

        <AdminInput
          label="Admin Password"
          placeholder="Enter here"
          value={adminPassword}
          onChange={(e) => setAdminPassword(e.target.value)}
          $password
          $textCenter
          type="text"
          autoComplete="off"
        />
      </Div>

      <Button $selected $w="100%" $mt="50" $mtSM="30" onClick={handleAddBank}>
        Save
      </Button>
      <Button
        $selected
        $gray
        $w="100%"
        $mt="16"
        onClick={() => setEditPendingBalanceModal(false)}
      >
        Cancel
      </Button>
    </Modal>
  );
};
